import { ChannelStatusListener } from 'core/models/channel';
import { getJanusVideoRoomConnector, JanusVideoRoomConnector } from 'infrastructure/connectors/JanusVideoRoomConnector';
import { TimestampDecodingConnector } from 'infrastructure/connectors/TimestampDecodingConnector';
import { ignore } from 'utility/ignore';
import { T4APIChannel } from './Channel';

export class CompanionChannel extends T4APIChannel {
    constructor(private readonly mainChannel: T4APIChannel, subChannelIndex: number) {
        super(
            {
                type: 'camera',
                id: `${mainChannel.mediaDeviceId}_${subChannelIndex}`,
                tag: 'companion',
            },
            mainChannel.projectId,
            mainChannel.environmentId,
            mainChannel.apiCall,
            mainChannel.mediaDeviceRepository);
    }

    protected async createConnector() {
        await this.mainChannel.prepare();

        const mainConnector = this.mainChannel.getConnector();
        if (!mainConnector) {
            // not supported
            throw 'PANIC';
        }
        const janusConnector = getJanusVideoRoomConnector(mainConnector);
        if (!janusConnector) {
            // not supported
            throw 'PANIC';
        }

        const connector = new JanusVideoRoomConnector({
            ...janusConnector.getParams(),
            room: this.mediaDeviceId
        });

        if (mainConnector instanceof TimestampDecodingConnector) {
            return new TimestampDecodingConnector(connector);
        }

        return connector;
    }

    addStatusListener(listener: ChannelStatusListener): void {
        ignore(listener);
    }

    removeStatusListener(listener: ChannelStatusListener): void {
        ignore(listener);
    }
}
